import { Alert, Box, Button, Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { setShowModal } from "../../common-ui/modalSlice";

const REPORTS_URL = "https://reports.simpl.org/";

export const ClassicReportsDeprecationModal = () => {
  const dispatch = useDispatch();

  return (
    <Box sx={{ p: 2, width: "100%", maxWidth: 480, minWidth: 0 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Classic Reports have been deprecated. All reporting data is now
        centralized at{" "}
        <Link
          href={REPORTS_URL}
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          fontWeight={600}
        >
          {REPORTS_URL}
        </Link>
        .
      </Alert>
      <Button
        variant="contained"
        onClick={() => dispatch(setShowModal(false))}
        fullWidth
      >
        Close
      </Button>
    </Box>
  );
};
